<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="事件类型名称" >
            <template slot-scope="scope">
              {{ scope.row.event_type_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="列入原因">
            <template slot-scope="scope">
              {{ scope.row.include_reason || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="违法类型名称">
            <template slot-scope="scope">
              {{ scope.row.illegal_type_name || '-' }}
            </template>
        </el-table-column>

    </el-table>
  </div>
</template>

<script>
export default {
    name: 'violationEventList',
    data() {
        return {
            title: '违规事件',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>